import { render, staticRenderFns } from "./ArgumentarioV2.vue?vue&type=template&id=bfa3067e&scoped=true"
import script from "./ArgumentarioV2.vue?vue&type=script&lang=js"
export * from "./ArgumentarioV2.vue?vue&type=script&lang=js"
import style0 from "./ArgumentarioV2.vue?vue&type=style&index=0&id=bfa3067e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa3067e",
  null
  
)

export default component.exports